import React from 'react';
import Navbar from './components/Navbar';
import {Routes,Route} from 'react-router-dom';
import { useCallback } from 'react';
import Home from './pages/Home'
import About from './pages/About'
import Experience from './pages/Experience';
import Projects from './pages/Projects';
import FreePage from './pages/FreePage';
import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";



function App() {
  const init = useCallback(async (engine) => {
    await loadFull(engine);
  }, []);

  const firebaseConfig = {
    apiKey: "AIzaSyDaOXLorDwTjh-VxbKO_Dj777E69KIHbKg",
    authDomain: "portfoliowebsite-aeef5.firebaseapp.com",
    projectId: "portfoliowebsite-aeef5",
    storageBucket: "portfoliowebsite-aeef5.appspot.com",
    messagingSenderId: "873599042509",
    appId: "1:873599042509:web:388553c858b69d51ecfa84",
    measurementId: "G-GJEETJB3WV"
  };
  
  const app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(app);

  return (
    <>
      <Particles options={{}} init={init}/>
      <Navbar/>
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/About' element={<About/>}/>
        <Route path='/Experience' element={<Experience/>}/>
        <Route path='/Projects' element={<Projects/>}/>
      </Routes>
    </>
  );
}

export default App;
